<template>
    <div class="modal fade" :id="modalId" tabindex="-1" role="dialog" :aria-labelledby="modalId" aria-hidden="true">
        <div class="modal-dialog" :class="modalSizeModifier" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" :id="modalId">{{ modalTitle }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body" v-html="modalBody">
                </div>
                <div class="modal-footer">
                    <button v-if="secondaryButton" type="button" class="btn btn-primary" data-dismiss="modal">{{ secondaryButton }}</button>
                    <button v-if="primaryButton" type="button" class="btn btn-primary">{{ primaryButton }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            modalId: { type: String, required: true },
            modalTitle: { type: String, required: true },
            modalBody: { type: String, required: true },
            primaryButton: { type: String, required: false },
            secondaryButton: { type: String, required: false },
            modalSize: { type: String, required: false, default: null }
        },

        computed: {
            modalSizeModifier() {
                if (this.modalSize && this.modalSize !== 'md' && this.modalSize !== 'medium') {
                    if (this.modalSize === 'lg' || this.modalSize === 'large') {
                        return 'modal-lg';
                    }
                    else if (this.modalSize === 'sm' || this.modalSize === 'small') {
                        return 'modal-sm';
                    }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .modal {
        
        .modal-header {
            background-color: #eee;
            font-weight: 700;

            h5 {
                padding-left: 1rem;
                font-size: 1.3rem;
            }

            .close {
                font-size: 2rem;
                font-weight: 600;
                text-shadow: none;
                opacity: 1;
                padding-right: 1.5rem;

                &:focus {
                    outline: none;
                    box-shadow: none;
                }
            }
        }

        .modal-body {
            padding-left: 30px;
            padding-right: 40px;

            &::v-deep ul {
                margin-top: 15px;
                li {
                    margin-bottom: 15px;
                    list-style-type: none;
                    text-align: justify;
                }
            }
        }
    }
</style>